import GolfMain from './GolfMain.vue'
import GolfStore from './golfStore.js'

const components = {
    GolfMain,
}

export default {
    install(app, { store }) {
        Object.keys(components).forEach((name) => {
            const component = components[name];

            app.component(name, component);
        })
        
        if (typeof store !== 'undefined') {
            store.registerModule('golf', GolfStore)
        }
    }
}